import { useTranslation } from 'react-i18next';
import CreatableSelect from 'react-select/creatable';

import { useAppSelector } from '../../store/hooks';

export type Group = {
  value: string;
  label: string;
  score: number;
};

type GroupSelectProps = {
  onChange?: (value: Group) => void;
  value?: Group;
};

const GroupSelect = (props: GroupSelectProps) => {
  const consumptions = useAppSelector(state => state.consumptions.consumptions);
  const { t } = useTranslation();

  const options: Group[] = consumptions.map(consumption => ({
    value: consumption.id,
    label: consumption.name,
    score: consumption.score,
  }));

  return (
    <CreatableSelect
      isClearable
      noOptionsMessage={() => t('group.hint')}
      options={options}
      getNewOptionData={inputValue => {
        return {
          value: 'new',
          label: inputValue,
          score: 0,
        };
      }}
      onChange={value => {
        if (value) {
          props.onChange?.(value);
        }
      }}
      placeholder={consumptions.length === 0 ? t('group.create') : t('group.selectOrCreate') }
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          borderColor: state.isFocused ? '#8AADB8' : 'hsl(0, 0%, 80%)',
          boxShadow: state.isFocused ? '0 0 0 1px #8AADB8' : 'none',
          '&:hover': {
            borderColor: state.isFocused ? '#8AADB8' : 'hsl(0, 0%, 70%)',
          },
        }),
        option: (baseStyles, state) => ({
          ...baseStyles,
          backgroundColor: state.isFocused ? '#ADD8E6' : state.isSelected ? '#8AADB8' : 'white',
        }),
      }}
      value={props.value}
    />
  );
};

export default GroupSelect;
